import { useEffect, useState } from "react";

export const Bolt = () => (
  <svg className="bolt" viewBox="0 0 32 32" aria-hidden="true">
    <rect width="32" height="32" rx="8" />
    <path d="M18 4 8 18h7l-2 10 11-15h-7z" />
  </svg>
);

function loadAds() {
  const id = "";
  if (!id) return;
  const s = document.createElement("script");
  s.async = true;
  s.crossOrigin = "anonymous";
  s.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=" + id;
  document.head.appendChild(s);
}

function loadGA() {
  const id = "";
  if (!id) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://www.googletagmanager.com/gtag/js?id=" + id;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(["js", new Date()]);
  window.dataLayer.push(["config", id]);
}

const FLINKS = [
  ["/guides/", "Alle guides"],
  ["/emne/spar-stroem/", "Spar strøm"],
  ["/emne/smart-home/", "Smart home"],
  ["/emne/varme/", "Varme"],
  ["/emne/belysning/", "Belysning"],
  ["/emne/elpris/", "Elpris"],
  ["/emne/tilskud/", "Tilskud"],
  ["/emne/elbil/", "Elbil"],
  ["/emne/solceller/", "Solceller"],
  ["/beregner/", "Beregnere"],
  ["/elpriser/", "Elpriser i dag"],
  ["/om/", "Om os"],
  ["/affiliate-oplysning/", "Affiliate-oplysning"],
  ["/privatliv/", "Privatliv og cookies"],
  ["/feed.xml", "RSS"],
];

const slug = (s) =>
  s.toLowerCase().replace(/ø/g, "o").replace(/æ/g, "ae").replace(/å/g, "a").replace(/[^a-z0-9]+/g, "-");

export default function Layout({ children }) {
  const [consent, setConsent] = useState(() => {
    try {
      return localStorage.getItem("cc");
    } catch (e) {
      return "0";
    }
  });

  useEffect(() => {
    if (consent === "1") {
      loadAds();
      loadGA();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ccSet = (v) => {
    try {
      if (v === null) localStorage.removeItem("cc");
      else localStorage.setItem("cc", v);
    } catch (e) {}
    setConsent(v);
    if (v === "1") {
      loadAds();
      loadGA();
    }
  };

  return (
    <>
      <a className="skip" href="#main">
        Spring til indhold
      </a>
      <header className="site">
        <div className="wrap bar">
          <a className="logo" href="/" data-testid="header-logo">
            <Bolt />
            <span>Forbrugsregner</span>
          </a>
          <nav aria-label="Hovedmenu">
            <a href="/guides/" data-testid="nav-guides-link">
              Guides
            </a>
            <a href="/elpriser/" data-testid="nav-elpriser-link">
              Elpriser
            </a>
            <a href="/beregner/" data-testid="nav-beregner-link">
              Beregner
            </a>
            <a href="/om/" data-testid="nav-om-link">
              Om os
            </a>
          </nav>
        </div>
      </header>
      {children}
      <footer className="site">
        <div className="wrap">
          <div className="fgrid">
            <div>
              <a className="logo" href="/" style={{ margin: 0 }} data-testid="footer-logo">
                <Bolt />
                <span>Forbrugsregner</span>
              </a>
              <p>
                Spar penge på strøm og varme – uden at gætte. Indholdet er vejledende og erstatter ikke rådgivning fra
                en autoriseret installatør eller dit elselskab.
              </p>
            </div>
            <div className="flinks">
              {FLINKS.map(([href, label]) => (
                <a key={href} href={href} data-testid={"footer-link-" + slug(label)}>
                  {label}
                </a>
              ))}
              <a
                href="#skift-cookie-valg"
                data-testid="footer-cookie-reset-link"
                onClick={(e) => {
                  e.preventDefault();
                  ccSet(null);
                }}
              >
                Skift cookie-valg
              </a>
            </div>
          </div>
          <p>© 2026 Forbrugsregner</p>
        </div>
      </footer>
      {consent === null && (
        <div id="cc" role="dialog" aria-label="Cookies" style={{ display: "block" }} data-testid="cookie-banner">
          <span>
            Vi bruger cookies til statistik og annoncer, hvis du siger ja. <a href="/privatliv/">Læs mere</a>
          </span>
          <div>
            <button data-testid="cookie-accept-button" onClick={() => ccSet("1")}>
              Acceptér
            </button>
            <button className="alt" data-testid="cookie-decline-button" onClick={() => ccSet("0")}>
              Kun nødvendige
            </button>
          </div>
        </div>
      )}
    </>
  );
}
